import MarketingReport from './MarketingReport';

export default MarketingReport;
